import {createApp} from 'vue';
import EventsCalendarApp from './events-calendar/EventsCalendarApp';
import {initElements} from "../define/shared"

export default function initEventsCalendar() {
    initElements(".eventsCalendar", eventsCalendar => {
        const calendarEl = eventsCalendar.querySelector('#calendar-app')
        const dataEl = eventsCalendar.querySelector('#calendar-data');

        const props = JSON.parse(dataEl.innerText || '{}');
        const app = createApp(EventsCalendarApp, props);

        app.mount(calendarEl)
    })
}
